import React, { useContext, useEffect } from "react";
import AppContext from "../contexts/AppContext";
import { setAuthCurrentUser } from "../actions";
import {
  useLocation,
  Route,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
// @material-ui/icons components
import { Auth, Hub } from "aws-amplify";

// core components
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Sidebar from "../components/sidebar";
import NavbarDropdown from "../components/navbar_dropdown";
import { routes } from "../routes";
import componentStyles from "../assets/styles/layouts/default_layout";

const useStyles = makeStyles(componentStyles);

const Admin = () => {
  const { dispatch } = useContext(AppContext);
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    async function getCurrentAuthenticatedUser() {
      const userInfo = await Auth.currentUserInfo();
      if (userInfo) {
        setAuthCurrentUser(dispatch, userInfo.username);
      } else {
        await Auth.signOut();
      }
    }
    getCurrentAuthenticatedUser();

    Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signIn":
          setAuthCurrentUser(dispatch, data.payload.data.username);
          break;
        case "signOut":
          history.push({ pathname: "/" });
          break;
        default:
          break;
      }
    });
  }, []);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    // mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((route, index) => {
      return (
        <Route
          exact
          path={route.path}
          component={route.component}
          key={index}
        />
      );
    });
  };

  return (
    <>
      <>
        <Sidebar
          logo={{
            innerLink: "/admin/index",
            imgSrc:
              require("../assets/images/redmic-bridge_logo_horizontal.png")
                .default,
            imgAlt: "...",
          }}
          dropdown={<NavbarDropdown />}
        />
        <Box position="relative" className={classes.mainContent}>
          <Navbar />
          <Switch>
            {getRoutes(routes)}
            <Redirect from="*" to="/" />
          </Switch>
          <Container
            maxWidth={false}
            component={Box}
            classes={{ root: classes.containerRoot }}
          >
            <Footer />
          </Container>
        </Box>
      </>
    </>
  );
};

export default Admin;
